import { ContentContainer } from "../../../../components/Content/ContentContainer.tsx";
import { Spinner } from "../../../../components/Spinner/Spinner.tsx";
import type { Content } from "../../types.ts";
import { LoadingTile } from "./LoadingTile.tsx";

export const GeneratedContentContainer = ({
  content,
  contentClassName,
  allowGrow = false,
  isLoading = false,
}: {
  content: Content;
  contentClassName?: string;
  allowGrow?: boolean;
  isLoading?: boolean;
}) => (
  <ContentContainer
    resourceType={content.resource_type}
    width={content.width ?? undefined}
    height={content.height ?? undefined}
    src={content.url}
    contentClassName={contentClassName}
    overridingComponent={
      isLoading ? (
        <div className="h-full w-full flex-col-center">
          <Spinner />
        </div>
      ) : content.status === "PROCESSING" || content.url === null ? (
        <LoadingTile content={content} className="h-full w-full" />
      ) : null
    }
    allowGrow={allowGrow}
  />
);
